import { api } from "../../api";

export const taskTemplatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get all task templates
    getTaskTemplates: builder.query({
      query: ({
        industry,
        category,
        appType,
        appliesTo,
        active,
        page = 1,
        limit = 50,
      } = {}) => {
        const params = new URLSearchParams();
        if (industry) params.append("industry", industry);
        if (category) params.append("category", category);
        if (appType) params.append("appType", appType);
        if (appliesTo) params.append("appliesTo", appliesTo);
        if (active !== undefined) params.append("active", String(active));
        params.append("page", page.toString());
        params.append("limit", limit.toString());
        return `tasks/templates?${params}`;
      },
      transformResponse: (response) => response.data,
      providesTags: ["TaskTemplates"],
    }),

    // Get single task template
    getTaskTemplate: builder.query({
      query: (id) => `tasks/templates/${id}`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, id) => [{ type: "TaskTemplates", id }],
    }),

    // Create task template
    createTaskTemplate: builder.mutation({
      query: (templateData) => ({
        url: "tasks/templates",
        method: "POST",
        body: templateData,
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ["TaskTemplates"],
    }),

    // Update task template
    updateTaskTemplate: builder.mutation({
      query: ({ id, ...templateData }) => ({
        url: `tasks/templates/${id}`,
        method: "PUT",
        body: templateData,
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: (result, error, { id }) => [
        "TaskTemplates",
        { type: "TaskTemplates", id },
      ],
    }),

    // Delete task template
    deleteTaskTemplate: builder.mutation({
      query: (id) => ({
        url: `tasks/templates/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["TaskTemplates"],
    }),

    // Get template analytics (placeholder - can be implemented later)
    getTaskTemplateAnalytics: builder.query({
      query: ({ timeframe = "30d" } = {}) =>
        `tasks/templates/analytics?timeframe=${timeframe}`,
      transformResponse: (response) => response.data || [],
      providesTags: ["TaskTemplateAnalytics"],
    }),

    // Get available templates for leg
    getAvailableTemplatesForLeg: builder.query({
      query: ({ appType } = {}) => {
        const params = new URLSearchParams({
          appliesTo: "leg",
          active: "true",
        });
        if (appType) params.append("appType", appType);
        return `tasks/templates?${params}`;
      },
      transformResponse: (response) => response.data || [],
      providesTags: (result, error, legId) => [
        { type: "AvailableTemplates", id: legId },
      ],
    }),

    // Apply templates to leg
    applyTemplateToLeg: builder.mutation({
      query: ({ legId, appType }) => ({
        url: `tasks/leg/${legId}/apply-templates`,
        method: "POST",
        body: { appType },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: (result, error, { legId }) => [
        { type: "Legs", id: legId },
        { type: "LegTasks", id: legId },
        { type: "AvailableTemplates", id: legId },
      ],
    }),
  }),
});

export const {
  useGetTaskTemplatesQuery,
  useGetTaskTemplateQuery,
  useCreateTaskTemplateMutation,
  useUpdateTaskTemplateMutation,
  useDeleteTaskTemplateMutation,
  useGetTaskTemplateAnalyticsQuery,
  useGetAvailableTemplatesForLegQuery,
  useApplyTemplateToLegMutation,
} = taskTemplatesApi;
